import { Grid } from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import CustomTooltip from '../CustomTooltip';
import useStyles from './styles';

const isElementElided = (el, str) => {
  const testEl = document.createElement('div');
  testEl.style.backgroundColor = 'transparent';
  testEl.style.color = 'transparent';
  testEl.style.pointerEvents = 'none';
  testEl.style.position = 'absolute';
  testEl.innerText = str;

  document.body.appendChild(testEl);
  const testElWidth = testEl.offsetWidth;
  const elWidth = el.offsetWidth;

  document.body.removeChild(testEl);
  return testElWidth > elWidth;
};

const TextOverflowTooltip = ({ children, text, ...props }) => {
  const styles = useStyles();
  const ref = useRef(null);
  const [isElided, setIsElided] = useState(false);
  const [useWrappedChildren, setUseWrappedChildren] = useState(true);

  useEffect(() => {
    if (ref && ref.current) {
      setIsElided(isElementElided(ref.current, text));
      setUseWrappedChildren(false);
    }
  }, [ref, setIsElided, setUseWrappedChildren, text]);

  if (isElided) {
    return (
      <CustomTooltip {...props} className={classNames(styles.textOverflowTooltip, props.className)}>
        {children}
      </CustomTooltip>
    );
  }

  return useWrappedChildren ? (
    <Grid ref={ref} className={styles.grid}>
      {children}
    </Grid>
  ) : (
    <>{children}</>
  );
};

TextOverflowTooltip.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.string]).isRequired,
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
};

TextOverflowTooltip.defaultProps = {
  className: '',
};

export default TextOverflowTooltip;
